import { useIntl } from 'react-intl'
import type { Product } from './types'
import { productHeaders } from './constants'
import {
	DataTable,
	FontIcon,
	ListItem,
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
} from 'react-md'
import { TableContainer } from 'ui/StyledComponents/Tables'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import ProductRow from './ProductRow'

const StyledDataTable = styled(DataTable)`
	height: calc(100vh - 265px);
	max-height: calc(100vh - 265px);
	td {
		white-space: nowrap;
	}
`

type ProductTableProps = {
	products: Product[]
}

const PurchaseInvoiceTable = ({ products }: ProductTableProps) => {
	const intl = useIntl()
	const dispatch = useDispatch()

	const handleOnClick = (uuid: string) => {
		dispatch(
			push(window.location.pathname + window.location.hash + '?uuid=' + uuid),
		)
	}

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{productHeaders
					.filter((h) => h.show)
					.map((header) => (
						//@ts-ignore //TODO: REMOVE
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
			</TableRow>
		)
	}

	return (
		<TableContainer>
			<StyledDataTable plain>
				<TableHeader
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 1,
					}}
				>
					{renderTableHeaders()}
				</TableHeader>

				<TableBody>
					{products
						.map((product) => (
							<ProductRow
								key={product.uuid}
								product={product}
								menuItems={[
									<ListItem
										key={1}
										primaryText={intl.formatMessage({
											defaultMessage: 'Muokkaa tuotetta',
											description: 'Edit product',
										})}
										leftIcon={<FontIcon>edit</FontIcon>}
										onClick={() => {}}
										className="md-divider-border md-divider-border--right"
									/>,
									<ListItem
										key={2}
										primaryText={intl.formatMessage({
											defaultMessage: 'Kopioi tuote',
											description: 'Copy product',
										})}
										leftIcon={<FontIcon>edit</FontIcon>}
										onClick={() => {}}
										className="md-divider-border md-divider-border--right"
									/>,
									<ListItem
										key={3}
										primaryText={intl.formatMessage({
											defaultMessage: 'Mitätöi tuote',
											description: 'Void product',
										})}
										leftIcon={<FontIcon>edit</FontIcon>}
										onClick={() => {}}
										className="md-divider-border md-divider-border--right"
									/>,
									<ListItem
										key={4}
										primaryText={intl.formatMessage({
											defaultMessage: 'Palauta tuote',
											description: 'Return product',
										})}
										leftIcon={<FontIcon>edit</FontIcon>}
										onClick={() => {}}
										className="md-divider-border md-divider-border--right"
									/>,
								]}
								children={null}
								processing={false}
								handleOnClick={() => handleOnClick(product.uuid)}
							/>
						))
						.concat(
							<tr
								key="empty-row"
								className="full-width"
								style={{ height: 100 }}
							></tr>,
						)}
				</TableBody>
			</StyledDataTable>
		</TableContainer>
	)
}

export default PurchaseInvoiceTable
